import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("pg_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export function formatApiError(detail) {
  if (detail == null) return "Une erreur est survenue. Réessayez.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const openPunch = () => api.get("/punch/open").then((r) => r.data);
export const openModuleSso = (key) => api.get(`/module/${key}/open`).then((r) => r.data);

// PROGÈRE CLOUD CONNECT
export const getCloudStatus = (provider = "onedrive") =>
  api.get("/cloud/status", { params: { provider } }).then((r) => r.data);
export const getCloudContract = () => api.get("/cloud/contract/active").then((r) => r.data);
export const acceptCloudContract = (payload) => api.post("/cloud/contract/accept", payload).then((r) => r.data);
export const disconnectCloud = (provider = "onedrive") =>
  api.post("/cloud/disconnect", null, { params: { provider } }).then((r) => r.data);
export const getCloudAudit = (limit = 50) =>
  api.get("/cloud/audit", { params: { limit } }).then((r) => r.data);
export const getCloudProof = (id) => api.get(`/cloud/acceptance/${id}/proof`).then((r) => r.data);
export const onedriveConnectUrl = () => `${API}/cloud/microsoft/start`;
export const getCloudCatalog = () => api.get("/cloud/catalog").then((r) => r.data);
export const getCloudPolicies = (provider = "onedrive") =>
  api.get("/cloud/policies", { params: { provider } }).then((r) => r.data);
export const updateCloudPolicies = (provider, policies) =>
  api.put("/cloud/policies", { provider, policies }).then((r) => r.data);
export const revokeCloudAi = (payload) => api.post("/cloud/ai/revoke", payload).then((r) => r.data);
export const getCloudProjects = () => api.get("/cloud/projects").then((r) => r.data);
export const createCloudProject = (name, code) => api.post("/cloud/projects", { name, code }).then((r) => r.data);
export const deleteCloudProject = (id) => api.delete(`/cloud/projects/${id}`).then((r) => r.data);
export const cloudSyncNow = (provider = "onedrive") =>
  api.post("/cloud/sync", null, { params: { provider } }).then((r) => r.data);
export const getCloudJobs = () => api.get("/cloud/jobs").then((r) => r.data);
export const getCloudModuleStatus = (module, provider = "onedrive") =>
  api.get(`/cloud/module/${module}/status`, { params: { provider } }).then((r) => r.data);
export const getCloudModuleFiles = (module, projectId, provider = "onedrive") =>
  api.get(`/cloud/module/${module}/files`, { params: { provider, project_id: projectId } }).then((r) => r.data);
export const getCloudAiStatus = (provider = "onedrive") =>
  api.get("/cloud/ai/status", { params: { provider } }).then((r) => r.data);

// Activation Microsoft Cloud Connect
export const getMsActivation = () => api.get("/cloud/microsoft/activation").then((r) => r.data);
export const requestMsActivation = (payload) =>
  api.post("/cloud/microsoft/activation-request", payload).then((r) => r.data);
export const acceptMsFees = (payload) =>
  api.post("/cloud/microsoft/activation/accept-fees", payload).then((r) => r.data);
export const payMsActivation = (origin) =>
  api.post("/cloud/microsoft/activation/pay", { origin }).then((r) => r.data);
export const getMsPaymentStatus = (sessionId) =>
  api.get("/cloud/microsoft/activation/payment-status", { params: { session_id: sessionId } }).then((r) => r.data);
// MASTER
export const listMsActivations = (status) =>
  api.get("/platform/ms-activations", { params: status ? { status } : {} }).then((r) => r.data);
export const msActivationAction = (id, action, body) =>
  api.post(`/platform/ms-activations/${id}/${action}`, body || {}).then((r) => r.data);
export const getMobileRedirectTarget = (source = "web") =>
  api.get(`/mobile/redirect-target`, { params: { source } }).then((r) => r.data);
export const notifyMobileLaunch = (email, lang = "fr", source = "web") =>
  api.post(`/mobile/notify-launch`, { email, lang }, { params: { source } }).then((r) => r.data);

// Lance un module : SSO direct si acheté ; sinon -> page d'achat ; repli -> connexion module.
// Retourne { ok } — ne toaste jamais (le composant appelant gère l'affichage si !ok).
export async function launchModule(key) {
  try {
    const { data } = await api.get(`/module/${key}/open`);
    if (data?.sso_url) {
      window.location.href = data.sso_url;
      return { ok: true };
    }
    if (data?.error === "sso_failed" && data?.login_url) {
      // Repli : connexion manuelle du module (SSO indisponible)
      window.location.href = data.login_url;
      return { ok: true, redirected: "login" };
    }
    return { ok: false, message: null };
  } catch (e) {
    const status = e?.response?.status;
    const detail = e?.response?.data?.detail;
    if (status === 403) {
      // Client sans accès -> page d'achat/tarification
      window.location.href = `/tarification?module=${key}`;
      return { ok: true, redirected: "pricing" };
    }
    return { ok: false, message: typeof detail === "string" ? detail : null };
  }
}

export default api;
